module.exports = __webpack_public_path__ + "static/media/oct30-9.492b18cb.png";